import { render, staticRenderFns } from "./haiguanCheck.vue?vue&type=template&id=0ed38ff8&"
import script from "./haiguanCheck.vue?vue&type=script&lang=js&"
export * from "./haiguanCheck.vue?vue&type=script&lang=js&"
import style0 from "./haiguanCheck.vue?vue&type=style&index=0&id=0ed38ff8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports